export default function getOffset(element, horizontal = false) {
    if (!element) return 0;
    // eslint-disable-next-line no-undef
    return getOffset(element.offsetParent, horizontal) + (horizontal ? element.offsetLeft : element.offsetTop);
}
